import { parserSelf } from '../../../common/utils/parserSelf';

export interface IActionUrlForm {
  enabled: boolean;
  title: string;
  url: string;
  parameters: Array<{
    parameterName: string;
    parameterValue: ParameterValues | undefined | '';
    numberReplacement: string[][];
  }>;
  trigger: TriggerValues | '';
  callType: CallTypes;
  urlTarget: string;
}

export interface IActionUrlDataFromServer extends IActionUrlForm {
  id: string;
}

export enum ParameterValues {
  caller_number = 'caller_number',
  attendant_name = 'attendant_name',
  attendant_extension = 'attendant_extension',
  attendant_email = 'attendant_email',
  attendant_location = 'attendant_location',
  custom = 'custom',
}

export enum CallTypes {
  all_calls = 'all_calls',
  queue_calls = 'queue_calls',
}

export enum UrlTargetTypes {
  tab = 'tab',
  window = 'window',
}

export enum TriggerValues {
  ringing = 'ringing',
  answered = 'answered',
  hangup = 'hangup',
  transferred = 'transferred',
}

export const actionUrlParser = {
  fromJson: (json: any) => {
    return {
      ...parserSelf.fromJson(json),
      id: json['id'],
      enabled: json['enabled'] ?? '',
      title: json['title'] ?? '',
      url: json['url'] ?? '',
      parameters: json['parameters'] ?? [],
      trigger: json['trigger'] ?? '',
      callType: json['callType'] ?? '',
      urlTarget: json['urlTarget'] ?? '',
    }
  }
}
